<template lang="pug">
    div.text-xs-left
        .ProductNote-title Producto {{slide.index}} - {{slide.product}}
        v-spacer.py-sm-3
        .ProductNote-question.pb-4 ¿Quieres agregar una nota a este producto para que aparezca en tu plan de vida?
        v-spacer.py-5
        v-text-field(label="Nota" :counter="40" :maxlengh="25" @blur="changeNote")
        viewPlanButton.ProductNote-view-button
</template>

<script>
import { mapGetters } from 'vuex';
import viewPlanButton from '@/components/life-plan/view-plan-button/view-plan-button';

export default {
  name: 'ProductNote',
  components:{
      viewPlanButton
  },
  computed: {
    ...mapGetters(['currentStep']),     
  },
  props: {
    slide: {
      type: Object,
      default: function () {
        return { }
      }
    }
  },
  data() {
      return {
          addToPlan: null
      }
  }, 
  methods: {
    changeNote(value) {
      // debugger
      this.$emit('productNoteChange', event.target.value);
    }
  },
}
</script>

<style scoped>
@import 'product-note.scss';
</style>

